<template>
	<div id="map-wrap">
		<div class="sidebar-wrap" :class="{'open': showSidebar, 'no-location-set': !hasLocation}">
			<div class="sidebar-toggle" @click="toggleSidebar">
				<i class="fas fa-caret-left"></i>
			</div>

			<div class="list-wrap">
				<div class="address-input-wrap">
					<p class="search-title">{{ strings.findExpert }}</p>

					<div class="fields">
						<input type="text" id="address" :placeholder="strings.locationPlaceholder" v-model="maps.address">
					</div>
				</div>

				<div class="collapsible-wrap" :class="{'mobile-open': mobileShowList}">
					<div class="filters">
						<div class="left-actions">
							<a class="clear" @click="navigateToDefault" v-show="!showAgronomist && !cluster">{{ strings.clearResults }}</a>

							<a @click="backToResults" v-show="showAgronomist">
								<svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M0.234375 3.98438L3.98438 0.234375C4.23828 0 4.62891 0 4.88281 0.234375C5.11719 0.488281 5.11719 0.878906 4.88281 1.13281L1.5625 4.43359L4.88281 7.73438C5.11719 7.98828 5.11719 8.37891 4.88281 8.63281C4.62891 8.86719 4.23828 8.86719 3.98438 8.63281L0.234375 4.88281C0 4.62891 0 4.23828 0.234375 3.98438Z" fill="currentColor"/>
								</svg>

 								{{ strings.backToResults }}
 							</a>

							<a @click="clearCluster" v-show="!showAgronomist && cluster && cluster.length">
								<svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M0.234375 3.98438L3.98438 0.234375C4.23828 0 4.62891 0 4.88281 0.234375C5.11719 0.488281 5.11719 0.878906 4.88281 1.13281L1.5625 4.43359L4.88281 7.73438C5.11719 7.98828 5.11719 8.37891 4.88281 8.63281C4.62891 8.86719 4.23828 8.86719 3.98438 8.63281L0.234375 4.88281C0 4.62891 0 4.23828 0.234375 3.98438Z" fill="currentColor"/>
								</svg>

 								{{ strings.backToResults }}</a>
						</div>

						<div class="toggles" v-show="!showAgronomist && !cluster">
		                    <trigger-popup :toggle-label="strings.sortBy">
		                    	<ul class="checkbox-wrapper">
		                            <li>
		                                <input class="custom-checkbox" v-model="query.sort" id="sort-proximity" type="radio" value="distance">

		                                <label for="sort-proximity">{{ strings.sortProximity }}</label>
		                            </li>

		                            <li>
		                                <input class="custom-checkbox" v-model="query.sort" id="sort-alphabetical" type="radio" value="alphabetical">

		                                <label for="sort-alphabetical">{{ strings.sortAlphabetical }}</label>
		                            </li>
		                        </ul>
		                    </trigger-popup>
		                </div>
					</div>

					<div class="results" :class="{'loading' : results.loading}" v-show="!showAgronomist">
						<div class="result" v-for="post in results.posts" :class="{'hovered': post.hovered}" @click="navigateToProfile(post.slug)" v-show="!cluster || cluster == post.meta.place_id" @mouseenter="setHoverPin(post.marker)" @mouseleave="setDefaultPin(post.marker)">
							<p class="about">
								<span class="name-designations">
									<strong class="full-name" v-html="post.meta.full_name"></strong>
									<span v-if="post.meta.designations" class="designations" v-html="post.meta.designations"></span>

									<br/>

									<span class="current_employer" v-html="parseEmployer(post.meta.current_employer)"></span>
								</span>
							</p>

							<div class="location-actions">
								<p v-if="post.meta.location">
									<span class="location" v-html="post.meta.location"></span>

									<span v-if="post.meta.distance" class="distance">{{ post.meta.distance }} {{ strings.distanceUnit }}</span>
								</p>

								<div class="action-icons">
									<a v-if="post.meta.website_url" :href="post.meta.website_url" target="_blank" rel="noopener nofollow" :title="strings.viewWebsite">
										<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M1.33594 4.78125L1.57031 5.17969C1.75781 5.50781 2.08594 5.76562 2.46094 5.88281L3.82031 6.25781C4.21875 6.375 4.5 6.75 4.5 7.17188V8.10938C4.5 8.36719 4.64062 8.60156 4.875 8.69531C5.08594 8.8125 5.25 9.04688 5.25 9.30469V10.2188C5.25 10.5938 5.57812 10.8516 5.92969 10.7578C6.32812 10.6406 6.60938 10.3359 6.70312 9.96094L6.77344 9.70312C6.86719 9.30469 7.125 8.97656 7.47656 8.76562L7.66406 8.64844C8.01562 8.46094 8.25 8.08594 8.25 7.6875V7.47656C8.25 7.19531 8.10938 6.89062 7.89844 6.67969L7.82812 6.60938C7.61719 6.39844 7.3125 6.25781 7.03125 6.25781H6.02344C5.74219 6.25781 5.48438 6.21094 5.27344 6.07031L4.45312 5.60156C4.35938 5.55469 4.28906 5.46094 4.24219 5.34375C4.17188 5.13281 4.26562 4.875 4.47656 4.78125L4.61719 4.71094C4.78125 4.61719 4.94531 4.61719 5.10938 4.66406L5.67188 4.85156C5.85938 4.92188 6.07031 4.82812 6.1875 4.66406C6.28125 4.5 6.28125 4.28906 6.14062 4.14844L5.83594 3.75C5.60156 3.46875 5.60156 3.07031 5.83594 2.78906L6.21094 2.36719C6.42188 2.10938 6.44531 1.78125 6.28125 1.5L6.23438 1.40625C6.14062 1.40625 6.07031 1.38281 5.97656 1.38281C3.82031 1.38281 1.96875 2.8125 1.33594 4.78125ZM10.875 6.25781C10.875 5.41406 10.6406 4.59375 10.2422 3.89062L9.65625 4.125C9.28125 4.28906 9.09375 4.6875 9.21094 5.0625L9.60938 6.25781C9.67969 6.49219 9.89062 6.67969 10.1484 6.75L10.8281 6.91406C10.8516 6.70312 10.8516 6.49219 10.8516 6.25781H10.875ZM0 6.25781C0 4.125 1.125 2.15625 3 1.07812C4.85156 0 7.125 0 9 1.07812C10.8516 2.15625 12 4.125 12 6.25781C12 8.41406 10.8516 10.3828 9 11.4609C7.125 12.5391 4.85156 12.5391 3 11.4609C1.125 10.3828 0 8.41406 0 6.25781Z" fill="#4D5452"/>
										</svg>
									</a>

									<a v-if="post.meta.phone_number" :title="strings.phoneAgronomist" :href="'tel:'+post.meta.phone_number">
										<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M3.84375 0.65625L4.78125 2.90625C4.94531 3.28125 4.85156 3.72656 4.52344 3.98438L3.375 4.94531C4.14844 6.58594 5.48438 7.92188 7.125 8.69531L8.08594 7.54688C8.34375 7.21875 8.78906 7.125 9.16406 7.28906L11.4141 8.22656C11.8594 8.39062 12.0703 8.88281 11.9531 9.32812L11.3906 11.3906C11.2734 11.7891 10.9219 12.0703 10.5 12.0703C4.6875 12.0703 0 7.38281 0 1.57031C0 1.14844 0.28125 0.796875 0.679688 0.679688L2.74219 0.117188C3.1875 0 3.67969 0.210938 3.84375 0.65625Z" fill="#4D5452"/>
										</svg>
									</a>

									<a v-if="post.meta.email" :title="strings.emailAgronomist" :href="'mailto:'+post.meta.email">
										<svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M1.125 0H10.875C11.4844 0 12 0.515625 12 1.125C12 1.5 11.8125 1.82812 11.5312 2.03906L6.44531 5.85938C6.16406 6.07031 5.8125 6.07031 5.53125 5.85938L0.445312 2.03906C0.164062 1.82812 0 1.5 0 1.125C0 0.515625 0.492188 0 1.125 0ZM0 2.625L5.08594 6.46875C5.625 6.86719 6.35156 6.86719 6.89062 6.46875L12 2.625V7.5C12 8.34375 11.3203 9 10.5 9H1.5C0.65625 9 0 8.34375 0 7.5V2.625Z" fill="#4D5452"/>
										</svg>
									</a>
								</div>
							</div>
						</div>

						<div class="empty result" v-if="loaded && !results.posts.length">
							<p v-if="!results.loading && hasLocation" class="has-small-font-size">{{ strings.noResults }}</p>
						</div>
					</div>

					<div class="summary-pagination" v-if="results.posts.length" v-show="!showAgronomist && !cluster">
						<p class="summary">{{ strings.summaryPrefix }} <span>{{ getStartingResult }}</span>-<span>{{ getEndResult }}</span> {{ strings.summarySuffix }} <span>{{ results.total }}</span></p>

						<div class="pagination">
							<a @click="loadPage(Math.max(results.page - 1, 1))" :class="{'disabled': results.page == 1}" :data-page="Math.max(results.page - 1, 1)">
								<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M0.273438 5.49609L5.52344 0.273438C5.76953 0 6.17969 0 6.45312 0.273438C6.69922 0.519531 6.69922 0.929688 6.45312 1.17578L1.64062 5.96094L6.42578 10.7734C6.69922 11.0195 6.69922 11.4297 6.42578 11.6758C6.17969 11.9492 5.76953 11.9492 5.52344 11.6758L0.273438 6.42578C0 6.17969 0 5.76953 0.273438 5.49609Z" fill="#1E2120"/>
								</svg>
							</a>

							<a @click="loadPage(Math.min(results.page + 1, results.maxPage))" :class="{'disabled': results.page == results.maxPage}" :data-page="Math.min(results.page + 1, results.maxPage)">
								<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M6.45312 5.49609C6.69922 5.76953 6.69922 6.17969 6.45312 6.42578L1.20312 11.6758C0.929688 11.9492 0.519531 11.9492 0.273438 11.6758C0 11.4297 0 11.0195 0.273438 10.7734L5.05859 5.98828L0.273438 1.17578C0 0.929688 0 0.519531 0.273438 0.273438C0.519531 0 0.929688 0 1.17578 0.273438L6.45312 5.49609Z" fill="#1E2120"/>
								</svg>
							</a>
						</div>
					</div>

					<div class="agronomist-wrap">
						<div class="agronomist" v-if="showAgronomist">
							<div class="agronomist-grid is-layout-flow" v-if="agronomist.data">
								<div class="image-name-wrap">
									<img v-if="agronomist.data.meta.image_url" :src="agronomist.data.meta.image_url" class="profile-image">
									<div v-else class="profile-image">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="30" height="30">
											<path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z" fill="#4D5452"/>
										</svg>
									</div>

									<div>
										<p class="name-designations">
											<strong>{{agronomist.data.meta.full_name}}</strong>
											<span class="designations" v-if="agronomist.data.meta.designations" v-html="agronomist.data.meta.designations"></span>

											<br/>

											<span class="current_employer" v-html="parseEmployer(agronomist.data.meta.current_employer)"></span>
										</p>

										<img v-if="agronomist.data.meta.logo_url" :src="agronomist.data.meta.logo_url" class="company-logo">

										<p class="location-distance" v-if="agronomist.data.meta.location">
											<span class="location" v-html="agronomist.data.meta.location"></span>

											<span v-if="agronomist.data.meta.distance" class="distance">{{ agronomist.data.meta.distance }} {{ strings.distanceUnit }}</span>
										</p>
									</div>
								</div>

								<div class="text-icon-wrap" v-if="agronomist.data.meta.street_address">
									<div class="icon address">
										<svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M5.03906 11.7188C4.75781 12.0703 4.21875 12.0703 3.9375 11.7188C2.74219 10.1953 0 6.5625 0 4.5C0 2.01562 2.01562 0 4.5 0C6.98438 0 9 2.01562 9 4.5C9 6.5625 6.25781 10.1953 5.03906 11.7188ZM4.5 3C3.96094 3 3.46875 3.30469 3.1875 3.75C2.92969 4.21875 2.92969 4.80469 3.1875 5.25C3.46875 5.71875 3.96094 6 4.5 6C5.01562 6 5.50781 5.71875 5.78906 5.25C6.04688 4.80469 6.04688 4.21875 5.78906 3.75C5.50781 3.30469 5.01562 3 4.5 3Z" fill="#4D5452"/>
										</svg>
									</div>

									<div class="text address">
										<a :href="agronomist.data.meta.directions_url" target="_blank" rel="nofollow noopener" v-html="agronomist.data.meta.street_address"></a>
									</div>
								</div>

								<div class="text-icon-wrap" v-if="agronomist.data.meta.phone_number">
									<div class="icon phone">
										<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M3.84375 0.65625L4.78125 2.90625C4.94531 3.28125 4.85156 3.72656 4.52344 3.98438L3.375 4.94531C4.14844 6.58594 5.48438 7.92188 7.125 8.69531L8.08594 7.54688C8.34375 7.21875 8.78906 7.125 9.16406 7.28906L11.4141 8.22656C11.8594 8.39062 12.0703 8.88281 11.9531 9.32812L11.3906 11.3906C11.2734 11.7891 10.9219 12.0703 10.5 12.0703C4.6875 12.0703 0 7.38281 0 1.57031C0 1.14844 0.28125 0.796875 0.679688 0.679688L2.74219 0.117188C3.1875 0 3.67969 0.210938 3.84375 0.65625Z" fill="#4D5452"/>
										</svg>
									</div>

									<div class="text phone">
										<a :href="'tel:'+agronomist.data.meta.phone_number" v-html="agronomist.data.meta.phone_number"></a>
									</div>
								</div>

								<div class="text-icon-wrap" v-if="agronomist.data.meta.website_url">
									<div class="icon website">
										<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M1.33594 4.78125L1.57031 5.17969C1.75781 5.50781 2.08594 5.76562 2.46094 5.88281L3.82031 6.25781C4.21875 6.375 4.5 6.75 4.5 7.17188V8.10938C4.5 8.36719 4.64062 8.60156 4.875 8.69531C5.08594 8.8125 5.25 9.04688 5.25 9.30469V10.2188C5.25 10.5938 5.57812 10.8516 5.92969 10.7578C6.32812 10.6406 6.60938 10.3359 6.70312 9.96094L6.77344 9.70312C6.86719 9.30469 7.125 8.97656 7.47656 8.76562L7.66406 8.64844C8.01562 8.46094 8.25 8.08594 8.25 7.6875V7.47656C8.25 7.19531 8.10938 6.89062 7.89844 6.67969L7.82812 6.60938C7.61719 6.39844 7.3125 6.25781 7.03125 6.25781H6.02344C5.74219 6.25781 5.48438 6.21094 5.27344 6.07031L4.45312 5.60156C4.35938 5.55469 4.28906 5.46094 4.24219 5.34375C4.17188 5.13281 4.26562 4.875 4.47656 4.78125L4.61719 4.71094C4.78125 4.61719 4.94531 4.61719 5.10938 4.66406L5.67188 4.85156C5.85938 4.92188 6.07031 4.82812 6.1875 4.66406C6.28125 4.5 6.28125 4.28906 6.14062 4.14844L5.83594 3.75C5.60156 3.46875 5.60156 3.07031 5.83594 2.78906L6.21094 2.36719C6.42188 2.10938 6.44531 1.78125 6.28125 1.5L6.23438 1.40625C6.14062 1.40625 6.07031 1.38281 5.97656 1.38281C3.82031 1.38281 1.96875 2.8125 1.33594 4.78125ZM10.875 6.25781C10.875 5.41406 10.6406 4.59375 10.2422 3.89062L9.65625 4.125C9.28125 4.28906 9.09375 4.6875 9.21094 5.0625L9.60938 6.25781C9.67969 6.49219 9.89062 6.67969 10.1484 6.75L10.8281 6.91406C10.8516 6.70312 10.8516 6.49219 10.8516 6.25781H10.875ZM0 6.25781C0 4.125 1.125 2.15625 3 1.07812C4.85156 0 7.125 0 9 1.07812C10.8516 2.15625 12 4.125 12 6.25781C12 8.41406 10.8516 10.3828 9 11.4609C7.125 12.5391 4.85156 12.5391 3 11.4609C1.125 10.3828 0 8.41406 0 6.25781Z" fill="#4D5452"/>
										</svg>
									</div>

									<div class="text website">
										<a :href="agronomist.data.meta.website_url" v-html="agronomist.data.meta.website_url" target="_blank" rel="nofollow noopener"></a>
									</div>
								</div>

								<div class="text-icon-wrap" v-if="agronomist.data.meta.email">
									<div class="icon email">
										<svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M1.125 0H10.875C11.4844 0 12 0.515625 12 1.125C12 1.5 11.8125 1.82812 11.5312 2.03906L6.44531 5.85938C6.16406 6.07031 5.8125 6.07031 5.53125 5.85938L0.445312 2.03906C0.164062 1.82812 0 1.5 0 1.125C0 0.515625 0.492188 0 1.125 0ZM0 2.625L5.08594 6.46875C5.625 6.86719 6.35156 6.86719 6.89062 6.46875L12 2.625V7.5C12 8.34375 11.3203 9 10.5 9H1.5C0.65625 9 0 8.34375 0 7.5V2.625Z" fill="#4D5452"/>
										</svg>
									</div>

									<div class="text email">
										<a :href="'mailto:'+agronomist.data.meta.email" v-html="agronomist.data.meta.email"></a>
									</div>
								</div>
							</div>

							<p class="disclaimer" v-else-if="!agronomist.loading">{{ strings.agronomistNotFound }}</p>
						</div>
					</div>
				</div>

				<div class="mobile-list-toggle mobile-only" v-if="hasLocation" @click="toggleMobileList">
					<a>
						<svg v-if="mobileShowList" width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M16 0.78125V11.7812C16 12.0625 15.8438 12.3438 15.5625 12.4688L11.6875 14.2812C11.2812 14.4688 10.8125 14.5 10.375 14.375L5.0625 12.5938L1.0625 14.4688C0.84375 14.5625 0.5625 14.5625 0.34375 14.4062C0.125 14.2812 0 14.0312 0 13.7812V2.78125C0 2.5 0.15625 2.21875 0.4375 2.09375L4.3125 0.28125C4.71875 0.09375 5.1875 0.0625 5.625 0.1875L11.0312 2.03125L14.9062 0.125C15.1562 0 15.4375 0 15.6562 0.15625C15.875 0.28125 16 0.53125 16 0.78125ZM4.5 1.84375L1.5 3.25V12.5938L4.5 11.1875V1.84375ZM6 11.3125L10 12.6562V3.28125L6 1.90625V11.3125ZM11.5 3.46875V12.7188L14.5 11.3125V2L11.5 3.46875Z" fill="#17442E"/>
						</svg>

						<svg v-else width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M0.75 0H2.25C2.65625 0 3 0.34375 3 0.75V2.25C3 2.65625 2.65625 3 2.25 3H0.75C0.34375 3 0 2.65625 0 2.25V0.75C0 0.34375 0.34375 0 0.75 0ZM5.25 0.75H14.75C15.1562 0.75 15.5 1.09375 15.5 1.5C15.5 1.90625 15.1562 2.25 14.75 2.25H5.25C4.84375 2.25 4.5 1.90625 4.5 1.5C4.5 1.09375 4.84375 0.75 5.25 0.75ZM5.25 5.75H14.75C15.1562 5.75 15.5 6.09375 15.5 6.5C15.5 6.90625 15.1562 7.25 14.75 7.25H5.25C4.84375 7.25 4.5 6.90625 4.5 6.5C4.5 6.09375 4.84375 5.75 5.25 5.75ZM5.25 10.75H14.75C15.1562 10.75 15.5 11.0938 15.5 11.5C15.5 11.9062 15.1562 12.25 14.75 12.25H5.25C4.84375 12.25 4.5 11.9062 4.5 11.5C4.5 11.0938 4.84375 10.75 5.25 10.75ZM0 5.75C0 5.34375 0.34375 5 0.75 5H2.25C2.65625 5 3 5.34375 3 5.75V7.25C3 7.65625 2.65625 8 2.25 8H0.75C0.34375 8 0 7.65625 0 7.25V5.75ZM0.75 10H2.25C2.65625 10 3 10.3438 3 10.75V12.25C3 12.6562 2.65625 13 2.25 13H0.75C0.34375 13 0 12.6562 0 12.25V10.75C0 10.3438 0.34375 10 0.75 10Z" fill="#17442E"/>
						</svg>

						{{ mobileListToggleLabel }}
					</a>
				</div>
			</div>
		</div>

		<div id="map"></div>

		<div id="search-here" v-if="showSearchHere" @click="searchHere">
			<span class="label">{{ strings.searchThisArea }}</span>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				namespace: '/wp-json/baytek/v1/agronomists',
				results: {
                    loading: false,
                    posts: [],
                    total: 0,
                    page: 1,
                    maxPage: 0
                },
                query: {
                    page: 1,
                    lat: '',
                    lng: '',
                    per_page: 20,
                    sort: 'distance'
                },
                loaded: false,
                showSidebar: true,
                mobileShowList: false,
                showSearchHere: false,
                agronomist: {
                	loading: false,
                	data: null,
                },
			}
		},

		computed: {
			strings() {
				return agronomist.i18n;
			},

			mobileListToggleLabel() {
				return this.mobileShowList ? this.strings.showMap : this.strings.showList;
			},

			hasLocation() {
				return this.loaded && this.query.lat && this.query.lng;
			},

			getStartingResult() {
				return (this.results.page - 1) * this.query.per_page + 1;
			},

			getEndResult() {
				return (this.results.page - 1) * this.query.per_page + this.results.posts.length;
			},

			showAgronomist() {
				return !!this.agronomistSlug;
			},

			cluster() {
				return this.$route.query.place_id;
			}
		},

		watch: {
			'$route.query'(to, from) {
				this.handleRouterQueries(to, from);
			},

			'maps.location'(to, from) {
				if (to && to.lat && to.lng) {
					//Update address
					if (!this.maps.address) {
						this.geocodeLocation();
					}

					//Draw map
					this.initMap();

					//Update query
					this.query.lat = to.lat;
					this.query.lng = to.lng;

					//Get single agronomist if applicable
					this.getAgronomist(this.agronomistSlug);
				}
				else {
					this.clearLocationAndResults();
				}
			},

			'query.sort'(val) {
				let query = Object.assign({}, this.$route.query);
				query.sort = val;
				if (query.pg) delete query.pg;
				this.$router.push({ path: this.$route.path, query });

				this.filterAgronomists();
			},

			'query.page'(val) {
				this.getAgronomists();
			},

			'query.lng'(val) {
				if (val) {
					this.updateMapCenter();
				}

				this.filterAgronomists();
			},

			'results.posts'(val) {
				this.updateMap();
			},

			agronomistSlug(val) {
				this.getAgronomist(val);
			},

			'$route.query.place_id'(val) {
				//unhover all other pins?
				this.defaultAllPins();
			},

			showSidebar(val) {
				// this.updateBounds();
			},

			hasLocation(val) {
				// this.updateBounds();
			},

			'agronomist.data'(val) {
				if (val && val.slug) {
					this.showSidebar = true;
					this.mobileShowList =  true;
				}

				if (val && val.marker) {
					//Let the mouseleave event fire first
					window.setTimeout(() => {
						this.setHoverPin(val.marker);
					}, 50);
				}

				//unhover all other pins?
				this.defaultAllPins();

				//Update document title
				this.setDocumentTitle(val && val.title ? val.title : '');
			},

			cluster(val) {
				if (val && val.length) {
					this.showSidebar = true;
					this.mobileShowList =  true;
				}
			}
		},

		created() {
			//Generate map pin SVGs
			this.setPinIcons();

			//Locate the user (if we don't have a location)
			if (!this.$route.query.lng || !this.$route.query.lat) {
				this.findUserLocation();
			}
		},

		mounted() {
			this.initGoogle();

			//Load some kind of map, if we don't have lat lng
			if (!this.$route.query.lng || !this.$route.query.lat) {
				this.initMap();
			}

			//jQuery event handling to support Vue JS
			this.handleFilterTriggers();
			this.handleInfoWindowClicks();

			//Set up all the things
			this.updatingFilters = true;
			this.handleRouterQueries(this.$route.query);

			//Handle race conditions
			//Map location update causes the map location watcher to set the pagination to 1
			//But only when there is also a type querystring
			//Adding the timeout gives the app a chance to resolve the location + types + pagination before querying
			window.setTimeout(() => {
				this.updatingFilters = false;

				//Now get agronomists
				this.getAgronomists();
			}, 300);
		},

		methods: {
			handleRouterQueries(to = {}, from = {}) {
				//Update maps values
				if (to.lng != from.lng || to.lat != from.lng) {
					if (to.lng && to.lat) {
						Vue.set(this.maps, 'location', {lng: parseFloat(to.lng), lat: parseFloat(to.lat)});
					}
					else {
						Vue.set(this.maps, 'location', null);
					}
				}

				if (to.address) {
					this.maps.address = to.address;
				}

				if (to.pg != from.pg) {
					if (to.pg) {
						Vue.set(this.query, 'page', to.pg);
					}
					else {
						Vue.set(this.query, 'page', 1);
					}
				}

				if (to.sort != from.sort) {
					Vue.set(this.query, 'sort', to.sort || 'distance');
				}
			},

			filterAgronomists() {
				if (this.updatingFilters) return;

                this.query.page = 1;

                this.getAgronomists();
            },

			getAgronomists() {
				//Make sure we have the required params
				if (!this.query.lng || !this.query.lat || !this.maps.map) return;

				//Don't double load
				if (this.results.loading || this.updatingFilters) return;
				this.results.loading = true;

				//Build request URL
				let bounds = this.maps.map.getBounds();
				let url = `${this.namespace}/browse?page=${this.query.page}&ne=${bounds.getNorthEast().lng()},${bounds.getNorthEast().lat()}&sw=${bounds.getSouthWest().lng()},${bounds.getSouthWest().lat()}&lat=${this.query.lat}&lng=${this.query.lng}&sort=${this.query.sort}`;

				//Fetch the data
				this.getData(url)
	                .then(json => {
	                	if (json.posts) {
		                    this.results.posts = json.posts;
		                    this.results.page = json.page;
		                    this.results.maxPage = json.maxPage;
		                    this.results.total = json.total;
		                }
	                })
	                .finally(() => {
	                    if (this.loaded) this.scrollUp();

	                    this.results.loading = false;
	                    this.loaded = true;
	                });
			},

			clearLocationAndResults() {
				//Stop reload
				this.updatingFilters = true;
				this.results.loading = true;

				//Clear maps
				this.maps.address = '';

				//Clear query
				this.query = {
					lat: '',
					lng: '',
					page: 1,
					per_page: 20,
					sort: 'distance'
				};

				//Clear results
				this.results = {
                    loading: false,
                    posts: [],
                    total: 0,
                    page: 1,
                    maxPage: 0
                };

                //Clear map
                this.clearMarkers();

                //Reset sidebar states
                this.showSidebar = true;
                this.mobileShowList = false;

                //Allow loading again
                this.updatingFilters = false;
                this.results.loading = false;
			},

			backToResults() {
				this.$router.push({ path: agronomist.mapPagePath, query: this.$route.query });
			},

			clearCluster() {
				//Delete the cluster query
				let query = Object.assign({}, this.$route.query);

				if (query.place_id) {
					delete query.place_id;
				}

				//Navigate
				this.$router.push({ path: this.$route.path, query: query});
			},

			toggleSidebar() {
				this.showSidebar = !this.showSidebar;
			},

			toggleMobileList() {
				this.mobileShowList = !this.mobileShowList;
			},

			getAgronomist(slug) {
				//Make sure we have a slug
				if (!slug || !slug.length) {
					//Null the data
					this.agronomist.data = null;
					return;
				}

				//If already loading, return
				if (this.agronomist.loading) return;
				this.agronomist.loading = true;

				//Empty our agronomist data
				this.agronomist.data = null;
				this.agronomist.error = null;
				this.agronomist.success = null;

				//See if we have this slug in our current set
				let agronomists = this.results.posts.filter((post) => { return post.slug == slug });

				if (agronomists.length) {
					this.agronomist.data = agronomists[0];
					this.agronomist.loading = false;
				}
				//Otherwise, we query it
				else {
					this.getData(`${this.namespace}/agronomist/${slug}?lat=${this.query.lat}&lng=${this.query.lng}`)
						.then(json => {
							if (json.post) {
								this.agronomist.data = json.post;
							}
						})
						.finally(() => {
							this.agronomist.loading = false;
						})
				}
			},


			defaultAllPins() {
				this.maps.markers.forEach((marker) => {
					this.setDefaultPin(marker);
				});
			}
		},
	}
</script>
